import { render, staticRenderFns } from "./orderManagement.vue?vue&type=template&id=548d9500&scoped=true"
import script from "./orderManagement.vue?vue&type=script&lang=js"
export * from "./orderManagement.vue?vue&type=script&lang=js"
import style0 from "./orderManagement.vue?vue&type=style&index=0&id=548d9500&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548d9500",
  null
  
)

export default component.exports